import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("app_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Optional root override from the URL (?permid=...). Falls back to backend default when absent/invalid.
const rootParams = () => {
  try {
    const v = new URLSearchParams(window.location.search).get("permid");
    return v && /^[A-Za-z0-9_-]{4,40}$/.test(v.trim()) ? { root: v.trim() } : {};
  } catch (e) {
    return {};
  }
};

export const api = {
  login: (password) => client.post("/auth/login", { password }),
  me: () => client.get("/auth/me"),
  getConfig: () => client.get("/config", { params: rootParams() }),
  getObjects: () => client.get("/objects", { params: rootParams() }),
  getIot: () => client.get("/iot", { params: rootParams() }),
  getMapLive: () => client.get("/map/live", { params: rootParams() }),
  getHome: (opts = {}) =>
    client.get("/home", {
      params: {
        ...rootParams(),
        ...(opts.refresh ? { refresh: 1 } : {}),
        ...(opts.viewer ? { viewer: opts.viewer } : {}),
      },
      timeout: opts.refresh ? 60000 : 15000,
    }),
  setHomeLocation: (permid, latitude, longitude) =>
    client.post("/home/set-location", { permid, latitude, longitude }),
  getObject: (permid) => client.get(`/objects/${permid}`),
  // --- map overlays (single, shared) ---
  getHomeOverlay: () => client.get("/home/overlays"),
  uploadHomeOverlay: (fd) =>
    client.post("/home/overlays", fd, { timeout: 60000 }),
  uploadHomeOverlayChunk: (fd) =>
    client.post("/home/overlays/chunk", fd, { timeout: 60000 }),
  completeHomeOverlay: (body) =>
    client.post("/home/overlays/complete", body, { timeout: 120000 }),
  saveHomeOverlayCorners: (oid, corners) =>
    client.put(`/home/overlays/${oid}/corners`, corners),
  updateHomeOverlayProps: (oid, props) => client.put(`/home/overlays/${oid}`, props),
  deleteHomeOverlay: (oid) => client.delete(`/home/overlays/${oid}`),
  autoPositionHomeOverlay: (oid, view) =>
    client.post(`/home/overlays/${oid}/auto-position`, view || {}, { timeout: 65000 }),
  homeOverlayImageUrl: (oid) => `${API}/home/overlays/${oid}/image`,
  createObject: (fd) => client.post("/objects", fd, { params: rootParams() }),
  updateObject: (permid, fd) => client.put(`/objects/${permid}`, fd),
  deleteObject: (permid) => client.delete(`/objects/${permid}`),
  w3w: (lat, lng) => client.get("/w3w", { params: { lat, lng } }),
  getSettings: () => client.get("/settings"),
  getVersion: () => client.get("/version"),
  updateSettings: (body) => client.put("/settings", body),
  imageUrl: (permid, w) =>
    `${API}/objects/${permid}/image${w ? `?w=${w}` : ""}`,
  // --- /test sandbox (local DB, no MWS) ---
  getTestOverlays: () => client.get("/test/overlays"),
  getTestSymbols: (overlayId) =>
    client.get("/test/symbols", {
      params: overlayId ? { overlay_id: overlayId } : {},
    }),
  saveTestOverlayCorners: (oid, corners) =>
    client.put(`/test/overlays/${oid}/corners`, corners),
  testOverlayImageUrl: (oid) => `${API}/test/overlays/${oid}/image`,
};

export default client;
